import React, { useState, useEffect } from "react";

interface CustomToggleButtonProps {
  onChange?: (enabled: boolean) => void;
  isOn?: boolean;
}

const CustomToggleButton: React.FC<CustomToggleButtonProps> = ({ onChange, isOn = false }) => {
  const [internalIsOn, setInternalIsOn] = useState(isOn);

  useEffect(() => {
    setInternalIsOn(isOn);
  }, [isOn]);

  const handleClick = () => {
    const newState = !internalIsOn;
    setInternalIsOn(newState);
    onChange?.(newState);
  };

  return (
    <button
      onClick={handleClick}
      className={`w-[55px] h-[24px] flex items-center px-1 rounded-full transition-all duration-300  ${
        internalIsOn ? "bg-[#00726B]" : "bg-gray-300"
      }`}
    >
      <div
        className={`w-[19px] h-[19px] bg-white rounded-full transform transition-all duration-300  ${
          internalIsOn ? "translate-x-[25px]" : "translate-x-[-2px]"
        }`}
      ></div>
    </button>
  );
};

export default CustomToggleButton;
